export default __webpack_public_path__ + "static/media/slider_1.9b11e793.jpg";